import { render, staticRenderFns } from "./order-items.vue?vue&type=template&id=7a5deb1d&scoped=true&"
import script from "./order-items.ts?vue&type=script&lang=ts&"
export * from "./order-items.ts?vue&type=script&lang=ts&"
import style0 from "./order-items.scss?vue&type=style&index=0&id=7a5deb1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5deb1d",
  null
  
)

export default component.exports